import CommonLayer from '../v2/modal/Layer'

import utils from './index'

const defaultOptions = {
  layer: false
}

let $Vue = null

class CommonModal {
  constructor (Vue, options = {}) {
    $Vue = Vue
    this.map = new Map()
    this.config = {
      ...defaultOptions,
      ...options
    }
  }

  /**
   * 实例化一个 CommonLayer 并挂载
   * @param {Object} props  CommonLayer 的props
   * @returns {Object} obj.layer 实例化的CommonLayer
   *                   obj.uuid  layer 的唯一id
   */
  mountLayer (props = {}) {
    let uuid = utils.guid()

    let container = document.createElement('div')
    container.id = uuid
    document.body.appendChild(container)

    let ComClass = $Vue.extend(CommonLayer)
    let layer = new ComClass({
      propsData: {
        id: uuid,
        ...props
      }
    }).$mount(container)

    if (!this.map.has(uuid)) {
      this.map.set(uuid, layer)
    }

    return {layer, uuid}
  }
  /**
   * 创建弹出层
   * @param {VueComponent} Component 要在弹出层上弹出的组件
   * @param {Object} props 弹出组件的属性
   * @param {Object} layerProps CommonLayer 组件的属性
   */
  createLayer (Component, props = {}, layerProps = {}, $on) {
    let instance = this.mountLayer(layerProps)
    this.add(instance, Component, props, $on)

    return {
      $instance: instance.layer,
      id: instance.uuid,
      destroy: () => {
        this.destroy(instance.uuid)
      },
      show: () => {
        this.show(instance.uuid)
      },
      hide: () => {
        this.hide(instance.uuid)
      }
    }
  }
  /**
   * 在公共弹出层上 弹出组件
   * @param {Object} Layer
   * @param {VueComponent} Layer.layer 实例化的 CommonLayer 组件
   * @param {String} Layer.uuid layer 的唯一id
   * @param {VueComponent} Component 需要在Layer 上弹出的组件
   * @param {Object} props Component 的属性
   * @param {Object} on    Component 可以绑定的自定义事件
   */
  add (Layer, Component, props = {}, on = {}) {
    const $on = {
      destroy: () => {
        this.destroy(Layer.uuid)
      },
      ...on
    }
    const com = {
      render: h => {
        return h(Component, { props, on: $on })
      }
    }
    Layer.layer.installComponent(com)
    return this
  }

  show (layerId) {
    const popup = this.map.get(layerId)
    popup && popup.show().showLayer()
  }

  hide (layerId) {
    const popup = this.map.get(layerId)
    popup && popup.hideLayer().hide()
  }

  destroy (layerId) {
    if (!layerId) {
      console.warn('参数 layerId 是必须的')
    }

    if (this.map.has(layerId)) {
      const popup = this.map.get(layerId)
      popup && popup.$destroy()
      this.map.delete(layerId)
    }
  }
}

export default CommonModal
